'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransactionalButton = require('./components/TransactionalButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransactionalButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/transactional/index.js
// module id = 228
// module chunks = 0 1 3 4 5